// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"879":"c7dd7727","957":"8127a4a3"}[chunkId] + ".css";
};